export const EDITOR_MEDIA_CACHE_START = 'EDITOR_MEDIA_CACHE_START';
export const EDITOR_MEDIA_CACHE_END = 'EDITOR_MEDIA_CACHE_END';
export const ADD_TO_MEDIA_CACHE = 'ADD_TO_MEDIA_CACHE';
